import Vue from 'vue';
import Router from 'vue-router';
import Step1 from '@/components/Step1.vue';
import Step2 from '@/components/Step2.vue';
import Step2Agency from '@/components/Step2Agency.vue';
import Step3 from '@/components/Step3.vue';
import Step4 from '@/components/Step4.vue';
import ImageViewNenkinTeikibin from '@/components/ImageViewNenkinTeikibin.vue';
import ImageViewNenkinHayamihyou from '@/components/ImageViewNenkinHayamihyou.vue';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/step1',
            name: 'Step1',
            component: Step1
        },
        {
            path: '/step2',
            name: 'Step2',
            component: Step2
        },
        {
            path: '/step2agency',
            name: 'Step2Agency',
            component: Step2Agency
        },
        {
            path: '/step3',
            name: 'Step3',
            component: Step3
        },
        {
            path: '/step4',
            name: 'Step4',
            component: Step4
        },
        {
            path: '/image-view-nenkin-teikibin',
            name: 'ImageViewNenkinTeikibin',
            component: ImageViewNenkinTeikibin
        },
        {
            path: '/image-view-nenkin-hayamihyou',
            name: 'ImageViewNenkinHayamihyou',
            component: ImageViewNenkinHayamihyou
        }
    ],
    scrollBehavior() {
        return {
            // selector: '.heading-01'
        };
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js